module.exports = __webpack_public_path__ + "static/media/finance.54f7d3e0.svg";